import { JobResponse } from '~/types/hlx/jobResponse';
import { withRequestDeadline } from '~/utils/requestDeadline';
import { postData } from '~/utils/service';
import { MARKET_ACTION_TIMEOUT_MS } from '../requestPolicy';

export type BeginNegotiationInput =
  | {
      listingType: 'JOB';
      jobListingId: number;
      negotiationTerms?: Record<string, unknown>;
    }
  | {
      listingType: 'MSAAS';
      msaasListingId: number;
      providerIds?: number[];
      negotiationTerms?: Record<string, unknown>;
    }
  | {
      listingType: 'SERVICE';
      jobResponseId?: number;
      providerServiceListingId: number;
      availabilityEntryIds: number[];
      negotiationTerms?: Record<string, unknown>;
    };

export type BeginNegotiationResponse = {
  jobResponseId: number;
  negotiationId: number;
  responseType: 'job' | 'msaas' | 'service';
  createdJobResponse: boolean;
  createdNegotiation: boolean;
  jobResponse: JobResponse;
};

export const beginNegotiation = async (
  input: BeginNegotiationInput,
  signal?: AbortSignal
): Promise<BeginNegotiationResponse> => {
  return await withRequestDeadline(
    (requestSignal) =>
      postData<BeginNegotiationResponse>('jobResponseBeginNegotiation', {
        data: input,
        signal: requestSignal,
      }),
    MARKET_ACTION_TIMEOUT_MS,
    signal
  );
};
